import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { submitReport } from '../apiClient';

const REPORT_TYPES = [
  { value: 'hateful', label: 'Hateful or Abusive' },
  { value: 'spam', label: 'Spam' },
  { value: 'inappropriate', label: 'Inappropriate Content' },
  { value: 'cheating', label: 'Cheating' },
  { value: 'other', label: 'Other' }
];

export default function ReportButton({ reportedUserId, reportedNickname, size = 'sm' }) {
  const { token } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [reportType, setReportType] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState(''); // '', 'sending', 'sent', 'error'

  const handleSubmit = async () => {
    if (!reportType) return;
    setStatus('sending');
    const result = await submitReport(token, reportedUserId, reportType, description);
    if (result.success) {
      setStatus('sent');
      setTimeout(() => { setShowModal(false); setStatus(''); setReportType(''); setDescription(''); }, 2000);
    } else {
      setStatus('error');
    }
  };

  const btnSize = size === 'sm' ? { fontSize: 11, padding: '2px 6px' } : { fontSize: 13, padding: '4px 10px' };

  return (
    <>
      <button onClick={() => setShowModal(true)} style={{
        background: 'transparent', border: 'none', color: '#484f58',
        cursor: 'pointer', ...btnSize
      }} title="Report user">
        Report
      </button>

      {showModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.7)', zIndex: 10000,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }} onClick={() => setShowModal(false)}>
          <div style={{
            background: '#161b22', border: '1px solid #30363d', borderRadius: 12,
            padding: 24, maxWidth: 400, width: '90%'
          }} onClick={e => e.stopPropagation()}>
            <h3 style={{ color: '#e2e8f0', fontSize: 18, marginBottom: 4 }}>Report Player</h3>
            <p style={{ color: '#8b949e', fontSize: 13, marginBottom: 16 }}>
              Report {reportedNickname || 'this player'}
            </p>

            {status === 'sent' ? (
              <div style={{
                background: '#1c3d2a', border: '1px solid #3fb950', color: '#3fb950',
                padding: '14px', borderRadius: 8, textAlign: 'center', fontSize: 14, fontWeight: 600
              }}>
                Report submitted. Thank you.
              </div>
            ) : (
              <>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 13, color: '#c9d1d9', marginBottom: 6 }}>Reason</label>
                  {REPORT_TYPES.map(t => (
                    <button key={t.value} onClick={() => setReportType(t.value)} style={{
                      display: 'block', width: '100%', textAlign: 'left',
                      padding: '8px 12px', marginBottom: 4,
                      background: reportType === t.value ? '#238636' : '#0d1117',
                      border: reportType === t.value ? '1px solid #3fb950' : '1px solid #21262d',
                      borderRadius: 6, color: reportType === t.value ? '#fff' : '#c9d1d9',
                      fontSize: 13, cursor: 'pointer'
                    }}>
                      {t.label}
                    </button>
                  ))}
                </div>

                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', fontSize: 13, color: '#c9d1d9', marginBottom: 6 }}>
                    Details (optional)
                  </label>
                  <textarea
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    placeholder="Describe what happened..."
                    maxLength={500}
                    style={{
                      width: '100%', minHeight: 60, padding: '8px 12px',
                      background: '#0d1117', border: '1px solid #30363d', borderRadius: 6,
                      color: '#e2e8f0', fontSize: 13, resize: 'vertical', boxSizing: 'border-box'
                    }}
                  />
                </div>

                {status === 'error' && (
                  <p style={{ color: '#f85149', fontSize: 12, marginBottom: 10 }}>Failed to submit report. Try again.</p>
                )}

                <div style={{ display: 'flex', gap: 10 }}>
                  <button onClick={handleSubmit} disabled={!reportType || status === 'sending'} style={{
                    flex: 1, background: !reportType ? '#21262d' : '#da3633', color: '#fff',
                    border: 'none', borderRadius: 6, padding: '10px', fontSize: 14,
                    fontWeight: 600, cursor: !reportType ? 'not-allowed' : 'pointer',
                    opacity: status === 'sending' ? 0.7 : 1
                  }}>
                    {status === 'sending' ? 'Submitting...' : 'Submit Report'}
                  </button>
                  <button onClick={() => setShowModal(false)} style={{
                    background: '#21262d', color: '#8b949e', border: '1px solid #30363d',
                    borderRadius: 6, padding: '10px 16px', fontSize: 14, cursor: 'pointer'
                  }}>
                    Cancel
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
